function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useQuery from '../../../helpers/hooks/useQuery';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
var AssetUsage = function AssetUsage() {
  var _useParams = useParams(),
    assetID = _useParams.assetID;
  var navigate = useNavigate();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useQuery = useQuery({
      api: "".concat(useSelector(function (s) {
        return s.config.endpoints.cms.assets;
      }), "/usage"),
      params: {
        assetID: assetID
      }
    }),
    response = _useQuery.response;
  var usageDict = {
    articleHero: 'Article Banner',
    articleSlideshow: 'Slideshow',
    pageBanner: 'Section Banner',
    sidebar: 'Sidebar Image',
    silhouette: 'Our Team Banner Silhouette',
    pageItemContact: 'Section Contact Slide-Out',
    projectIcon: 'Posillico Project Icon',
    pageBannerLogo: 'Section Banner Logo',
    posillicoLandingPageLogo: 'Posillico Landing Page Logo'
  };
  var cropDict = {
    articleHero: true,
    articleSlideshow: false,
    pageBanner: true,
    sidebar: true,
    silhouette: false,
    pageItemContact: false,
    projectIcon: false,
    pageBannerLogo: false,
    posillicoLandingPageLogo: false
  };
  useEffect(function () {
    if (!response || !('usage' in response)) return;
    var data = [];
    var usage = response.usage;
    Object.keys(usage).forEach(function (x) {
      usage[x].forEach(function (y) {
        var type = 'Article';
        switch (x) {
          case 'projectIcon':
            type = 'Posillico Project Icon';
            break;
          case 'pageItemContact':
            type = 'Section Contact Slide-Out';
            break;
          case 'pageBanner':
          case 'pageBannerLogo':
          case 'posillicoLandingPageLogo':
            type = 'Section';
            break;
          default:
            type = 'Article';
        }
        data.push({
          _id: y._id,
          type: type,
          title: y.title,
          app: type === 'Section' ? y.clientApp : '',
          position: usageDict[x],
          crop: cropDict[x] ? 'Yes' : 'No'
        });
      });
    });
    setData(data);
  }, [response]);
  var tableData = {
    data: data,
    columns: {
      _id: {
        title: 'ID',
        visible: false
      },
      type: {
        title: 'Type',
        size: 'contain'
      },
      app: {
        title: 'App',
        visible: false
      },
      title: 'Title',
      position: {
        title: 'Image Position',
        size: 'contain'
      },
      crop: {
        title: 'Crop',
        size: 'contain'
      }
    },
    tr: {
      onClick: function onClick(row) {
        if (row.type === 'Article') navigate("/article/".concat(row._id));else if (row.type === 'Section') navigate("/".concat(row.app, "/page/").concat(row._id));else if (row.type === 'Section Contact Slide-Out') navigate("/contact/".concat(row._id));else if (row.type === 'Posillico Project Icon') {
          // TODO :: Make link to project icon details
          navigate('/settings/project-icons');
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Usage"
  }), /*#__PURE__*/React.createElement(Table, tableData));
};
export default AssetUsage;